import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-welcome-planner-items',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './welcome-planner-items.component.html',
  styleUrls: ['./welcome-planner-items.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomePlannerItemsComponent {


}
